module.exports = {"name":"saaf-front","version":"3.4.31"}


//////////////////
// WEBPACK FOOTER
// ./src/saaf.version.json
// module id = ./src/saaf.version.json
// module chunks = 11